<template>
  <div class="container_top">
    <div class="container_auto">
      <el-row>
        <el-col :span="8">
          <div class="header">
            <a :href="homePage">
              <img v-if="$i18n.locale === 'en'" src="@/assets/image/en_logo.png" />
              <img v-if="$i18n.locale === 'zh'" src="@/assets/image/logo-white.png" />
              <img v-if="$i18n.locale === 'tw'" src="@/assets/image/logo_tw.png" />
            </a>
          </div>
        </el-col>
        <el-col :span="16" class="top_right_confim">
          <!-- <span class="img_tel"><img src="@/assets/image/tel-top.png" /></span> -->
          <span class="login_out" :title="$t('home.logout')" @click="_logOut">{{ $t('home.logout') }}</span>
          <!-- <span class="login_lang">
            <select v-model="isSelect" @change="changeLaguage($event)">
              <option
                v-for="(item, index) in options"
                :key="index"
                :value="item.value"
                >{{ item.label }}</option
              >
            </select>
          </span> -->
          <span class="live800" href="javascript:;" @click="handleServer">{{ $t('home.customer') }}</span>

          <span
            class="live800"
            style="color: #DC0406;"
            @click="
              () => {
                $router.push('/softDownload')
              }
            "
            >下载APP</span
          >
          <!-- <span class="net_text"
            ><a :href="homePage" target="_blank">{{
              $t("home.mcwebsite")
            }}</a></span
          > -->
          <span class="wellcome_text">{{ $t('home.welcome') }}</span>
          <span class="user-item user-name">{{ this.userName }}</span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { base64 } from '@/utils'
import { login } from '@/api'
import { server } from '@/mixins/server.js'
import { routers, enrouters } from '@/router/router.js'
import VueCookie from 'vue-cookie'
export default {
  mixins: [server],
  data() {
    return {
      userName: '',
      isSelect: 'zh',
      options: [
        {
          value: 'zh',
          label: '中文',
        },
        {
          value: 'en',
          label: 'English',
        },
        {
          value: 'tw',
          label: '繁體',
        },
      ],
    }
  },
  created() {
    // if(VueCookie.get('lang')){
    //   if(localStorage.getItem('lang') != VueCookie.get('lang')) {
    //     this.isSelect = VueCookie.get('lang')
    //   }
    // }
    // console.log('created=>' + localStorage.getItem('lang'))
  },

  computed: {
    homePage() {
      return '/'
      if (this.$store.state.userRole == 4 || this.$store.state.userRole == 5) {
        return '/'
      } else {
        let host = location.host
        if (host.indexOf('localhost') > -1 || host.indexOf('.lan') > -1 || host.indexOf('192.168') > -1) {
          this.accountUrl = 'http://www.proway.lan/'
        } else {
          this.accountUrl = `https://www.${this.$store.state.hostname}.com`
        }
        // return `https://www.${this.$store.state.hostname}.com/`
        return this.accountUrl
      }
    },
  },
  methods: {
    _setName() {
      let info = this.$store.state.userInfo
      this.userName = info.jfUser ? info.jfUser.name : info.name
    },
    _logOut() {
      const _this = this
      this.$confirm(this.$t('msg.loginout'), this.$t('commiss.tips'), {
        confirmButtonText: this.$t('bank.Confirm'),
        cancelButtonText: this.$t('fun.Cancel'),
        type: 'warning',
        customClass: 'logout_msgbox',
        center: true,
      })
        .then(() => {
          login
            .logout()
            .then(res => {
              if (res.IsSuccess) {
                _this.$cookie.delete('remember')
                location.reload()
              }
            })
            .catch(() => {
              _this.$message({
                type: 'warning',
                message: this.$t('msg.tryagain'),
              })
            })
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '取消退出'
          // });
        })
    },

    // 语言设置
    changeLaguage(event) {
      localStorage.setItem('lang', this.isSelect)
      this.$i18n.locale = this.isSelect
      document.title = this.$t('meta.base')
      this.$cookie.set('lang', this.isSelect, { expires: '365D' })
      this.$router.push({
        query: { lang: this.$i18n.locale },
      })
      // location.reload()
    },
  },
  mounted() {
    this._setName()
    if ('zh' !== localStorage.getItem('lang')) {
      this.$cookie.set('lang', 'zh', 30)
      this.$i18n.locale = 'zh'
      localStorage.setItem('lang', 'zh')
      this.isSelect = 'zh'
    }
  },
}
</script>
<style lang="scss">
@import '~scss/common/header.scss';
</style>



// WEBPACK FOOTER //
// src/views/common/header.vue